export enum FieldType {
	ATTACHMENTS,
	BOOLEAN,
	BUTTON_DROPDOWN,
	CHECKBOX,
	MULTI_CHECKBOX,
	OFFERING_FEATURE_MULTI_CHECKBOX,
	DATE,
	DATE_EXPIRED,
	DROPDOWN,
	ASYNC_DROPDOWN,
	ENUM,
	EMAIL,
	MULTI_DROPDOWN,
	NUMBER,
	PASSWORD,
	POSITIVE_INTEGER,
	RADIO_BUTTONS,
	STRING,
	SPECIAL_RENDER,
	TEXT_AREA,
	JSON_DICT,
	TIME_DIFF,
	TOGGLE_SWITCH,
	URL,
	USER,
}
